import { Component, HostListener, OnInit, Input } from '@angular/core';
import { TenantTag } from 'app/api/models/tenant/tenantTag';
import { TenantsService } from 'app/state/tenants.service';
import { Table } from 'primeng/table';
import { Tag } from 'primeng/tag';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'app-tenant-tags',
  templateUrl: './tenant-tags.component.html',
  styleUrls: ['./tenant-tags.component.scss'],
  standalone: false,
})
export class TenantTagsComponent implements OnInit {
  constructor(private tenantService: TenantsService) {}

  @Input({ required: true }) tenantId!: string;

  tags: TenantTag[] = [];
  newTagText: string = '';
  innerWidth = 0;
  deleteConf: {
    id: string;
    name: string;
  } | null = null;
  editTag: TenantTag | undefined;

  ngOnInit(): void {
    this.refreshData();
    this.innerWidth = window.innerWidth;
  }
  @HostListener('window:resize')
  onResize() {
    this.innerWidth = window.innerWidth;
  }

  addTag() {
    if (this.newTagText.trim()) {
      let newTag = new TenantTag();
      newTag.title = this.newTagText;
      this.tenantService
        .addTenantTag(this.tenantId, newTag)
        .pipe(untilDestroyed(this))
        .subscribe((x) => {
          this.refreshData();
          this.newTagText = '';
        });
    }
  }

  updateTag(newValue: string) {
    this.editTag!.title = newValue;
    this.tenantService.updateTenantTag(this.tenantId, this.editTag!)
      .pipe(untilDestroyed(this))
      .subscribe(() => {
        this.editTag = undefined;
        this.refreshData();
      });
  }

  refreshData() {
      this.tenantService.getAllTenantsTags(this.tenantId)
          .pipe(untilDestroyed(this))
          .subscribe((x) => {
      this.tags = x;
    });
  }

  onGlobalFilter(table: Table, event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    table.filterGlobal(inputElement.value, 'contains');
  }

  handleDeleteClick(id: string) {
    this.tenantService.deleteTenantTag(this.tenantId, id)
      .pipe(untilDestroyed(this))
      .subscribe(() => {
        this.refreshData();
      });
  }
}
